var React = require('react');

function ButtonStagePauseInline (props) {
    return React.createElement("g",props,React.createElement("g",{"transform":"translate(4.000000, 4.000000)"},[React.createElement("circle",{"fill":"#F5F2F0","cx":"23","cy":"23","r":"23","key":0}),React.createElement("g",{"transform":"translate(16.000000, 15.000000)","fill":"#262626","key":1},[React.createElement("rect",{"x":"0","y":"0","width":"5","height":"17","key":0}),React.createElement("rect",{"x":"9","y":"0","width":"5","height":"17","key":1})])]));
}

ButtonStagePauseInline.defaultProps = {"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = ButtonStagePauseInline;

ButtonStagePauseInline.default = ButtonStagePauseInline;
